var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84 42.001C84 65.1988 65.1975 84.0007 42.0007 84C18.8025 84.0007 5.26029e-08 65.1988 5.26029e-08 42.001C-0.00114838 18.8032 18.8025 0 42.0007 0C65.1975 0 84 18.8039 84 42.001Z",
    fill: "#2BA62C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.9532 43.8657C83.9337 43.8432 83.9142 43.8207 83.8929 43.7997C83.8563 43.7634 62.1196 22.0261 62.0737 21.9807C62.0373 21.9446 61.9966 21.9146 61.96 21.8788C61.9139 21.8326 61.875 21.7814 61.8286 21.7354C56.5343 16.4963 49.4555 13.67 41.9801 13.8165C34.4282 13.9462 27.3213 16.9971 21.9696 22.4069C16.5821 27.8527 13.6869 34.9853 13.8167 42.4907C13.9478 50.0413 16.9153 57.0638 22.173 62.2648C22.2101 62.3014 22.2513 62.332 22.2884 62.3683C22.3337 62.4137 22.3724 62.4646 22.4182 62.5099C22.4552 62.5465 43.8252 83.9059 43.8623 83.9424C43.8655 83.9456 43.8683 83.9494 43.8718 83.9527C65.581 83.0011 83.004 65.5764 83.9532 43.8657Z",
    fill: "#1E931F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.19 70.194C26.6854 70.194 14 57.5084 14 42.004C14 26.4995 26.6854 13.814 42.19 13.814C57.6946 13.814 70.3799 26.4995 70.3799 42.004C70.3799 57.5084 57.6945 70.194 42.19 70.194ZM42.19 15.9824C27.8781 15.9824 16.1685 27.6921 16.1685 42.004C16.1685 56.3158 27.8781 68.0255 42.19 68.0255C56.5019 68.0255 68.2114 56.3158 68.2114 42.004C68.2114 27.6921 56.5018 15.9824 42.19 15.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.9379 51.7619C38.7211 51.7619 38.5042 51.6535 38.2874 51.5451L27.4451 42.8712C27.0113 42.546 26.9029 41.7871 27.2282 41.3533C27.5536 40.9196 28.3124 40.8112 28.7462 41.1365L38.8295 49.1598L55.5266 30.4026C55.9604 29.9689 56.6108 29.8605 57.0446 30.2942C57.4783 30.7279 57.5867 31.3784 57.153 31.8121L39.8053 51.3283C39.5885 51.6535 39.2632 51.7619 38.9379 51.7619Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.166bd75c9a95c542d5d3f12e4d049825.svg";
export { ForwardRef as ReactComponent };